var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_399_1405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8249 0.956787H0.0566406V25.043H13.8249V0.956787Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_399_1405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.78119 25.043C1.44008 25.0429 1.10665 24.9417 0.823063 24.7521C0.539474 24.5625 0.318449 24.2932 0.187926 23.978C0.057403 23.6628 0.023241 23.3161 0.0897581 22.9815C0.156275 22.6469 0.320485 22.3396 0.561633 22.0984L9.66008 12.9999L0.561633 3.90146C0.24959 3.5757 0.077563 3.14067 0.0824147 2.68959C0.0872664 2.23851 0.268611 1.80728 0.587588 1.48831C0.906565 1.16933 1.3378 0.987984 1.78887 0.983132C2.23995 0.97828 2.67498 1.15031 3.00074 1.46235L13.3187 11.7803C13.6421 12.1038 13.8237 12.5425 13.8237 12.9999C13.8237 13.4573 13.6421 13.896 13.3187 14.2195L3.00074 24.539C2.84081 24.6995 2.65073 24.8268 2.44144 24.9135C2.23214 25.0003 2.00776 25.0448 1.78119 25.0446",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.c5da163ee9bbb04b4203299f69d7286e.svg";
export { ForwardRef as ReactComponent };